module.exports = __webpack_public_path__ + "static/11-3b36c7bf12a3e6aa5744cae502e79328.png";